import signinOrganizationTemplateUrl from './signinorganization.tpl.html';

export default {
    templateUrl: signinOrganizationTemplateUrl,
    controller: [
        'SUBDOMAIN_ROOT',
        '$scope',
        '$http',
        'API_URL',
        '$window',
        'ssoRedirect',
        'oauthBrokerContinuation',
        function (
            SUBDOMAIN_ROOT,
            $scope,
            $http,
            API_URL,
            $window,
            ssoRedirect,
            oauthBrokerContinuation
        ) {
            $scope.SUBDOMAIN_ROOT = SUBDOMAIN_ROOT;

            $scope.state = '';
            $scope.domain = '';
            let brokerFlowOwned = false;

            $scope.submit = function () {
                $scope.state = 'loading';
                const brokerInspection = oauthBrokerContinuation.inspect();
                brokerFlowOwned = brokerFlowOwned || brokerInspection.owned;
                const hasBrokerContinuation = brokerInspection.active;
                if (brokerFlowOwned && !hasBrokerContinuation) {
                    $scope.state = 'error';
                    return;
                }
                let url = '';
                if (!hasBrokerContinuation) {
                    url = ssoRedirect.getAndClear() || '';
                    // Redirect to '/home' when the cookie - SF_SSO_REDIRECT
                    // is set to redirect to a different org id i.e. /home/:orgId
                    const urlParams = url.split('/');
                    if (urlParams.length === 3 && urlParams[1] === 'home') {
                        url = '/home';
                    }
                }

                const domain = ($scope.domain || '').trim().toLowerCase();
                if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(domain)) {
                    $scope.state = 'error';
                    return;
                }

                const orgHost = domain + '.' + SUBDOMAIN_ROOT;
                const orgUrl = 'https://' + orgHost;
                $http
                    .post(API_URL + '/v2/organization/_/hasDomain', orgHost, {
                        headers: { 'Content-Type': 'text/plain' },
                    })
                    .then(
                        () => {
                            if (hasBrokerContinuation) {
                                const brokerUrl =
                                    oauthBrokerContinuation.buildCrossOriginUrl(orgUrl);
                                if (!brokerUrl) {
                                    $scope.state = 'error';
                                    return;
                                }
                                oauthBrokerContinuation.clear();
                                $window.location.href = brokerUrl;
                                return;
                            }

                            $window.location.href = orgUrl + '/#' + url;
                        },
                        () => {
                            $scope.state = 'error';
                        }
                    );
            };
        },
    ],
};
